import { CustomFieldApi } from "@/api/CustomFieldsApi";
import { useAppDispatch } from "@/store/hooks";
import { hasAdditionalData } from "@/store/slices/eDocumentSlides";
import DynamicForm, { Yup } from "@mavichpe/dynamic-forms";
import { chunkArray } from "@utils/Utils";
import { forwardRef, useEffect, useState } from "react";
import { Col, Row } from "reactstrap";

type CustomDocumentFieldsProps = {
  defaultData?: Record<string, string>,
  documentType: "invoice" | "quote"
}

const CustomDocumentFields = forwardRef<any, CustomDocumentFieldsProps>((props, ref) => {
  const { defaultData, documentType } = props
  const dispatch = useAppDispatch()

  const [formConfig, setFormConfig] = useState<any>({})
  const [visible, setVisible] = useState<boolean>(false)

  useEffect(() => {
    loadCustomFields()
  }, []);

  useEffect(() => {
    dispatch(hasAdditionalData(visible))
  }, [visible]);

  const loadCustomFields = async () => {
    const customFields = await CustomFieldApi.fetchByDocumentType(documentType);
    if (customFields?.fields) {
      const fieldOptions = JSON.parse(customFields.fields);
      const fields = chunkArray(fieldOptions.map((fo: { type: string, required: boolean, field_title: string }) => {
        return {
          "type": "",
          "name": fo.field_title,
          "label": fo.field_title,
          "labelSizing": {
            "sm": 3
          },
          "sizing": {
            "sm": 3
          },
          "validation": fo.required ? Yup.string().required("Este campo es requerido") : false,
        }
      }), 3)
      if (fields.length == 0) {
        setVisible(false)
      } else {
        setVisible(true)
      }

      const formConfig = {
        sections: [
          {
            hideBorderBottom: true,
            "fields": fields
          }
        ]
      }
      setFormConfig(formConfig)
    } else {
      setVisible(false)

    }

  }

  return visible && (
    <>
      <h3>Informacion Adicional</h3>
      <Row>
        <Col md={{
          offset: 1
        }}>
          <DynamicForm<Record<string, string>>
            externalFormState={defaultData}
            ref={ref}
            innerForm={true}
            formConfig={formConfig}
          >
          </DynamicForm>
        </Col>
      </Row>
      <hr />
    </>

  )
})

export default CustomDocumentFields;